import React, { useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Image } from "primereact/image";
import emptyPolicyBanner from "../../assets/images/empty-policy-banner.png";

const Homepage = () => {
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);

	const handleClick = () => {
    setLoading(true);
		
		navigate("/get-quotes");

		setTimeout(() => {
			setLoading(false);
		}, 2000);
	};

	return (
		<div className="main-content">
			<h2>Welcome back, John Doe</h2>
			<div className="card justify-content-center align-items-center border-radius-10">
				<div className="d-flex flex-column justify-content-center align-items-center p-my-4">
					<Image src={emptyPolicyBanner} alt="Insurance Image" width="250" />
					<p className="formatted-text">There is no policy in this account</p>
					<Button
						label="Get Quote Now"
						className="btn-primary get-quote-button"
						loading={loading}
						onClick={handleClick}
						size="large"
					/>
				</div>
			</div>
		</div>
	);
};

export default Homepage;
